"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationProfileMaterialType = void 0;
var LocationProfileMaterialType;
(function (LocationProfileMaterialType) {
    LocationProfileMaterialType[LocationProfileMaterialType["Cast Iron"] = 1] = "Cast Iron";
    LocationProfileMaterialType[LocationProfileMaterialType["PVC"] = 2] = "PVC";
    LocationProfileMaterialType[LocationProfileMaterialType["Lead"] = 3] = "Lead";
    LocationProfileMaterialType[LocationProfileMaterialType["Copper"] = 4] = "Copper";
    LocationProfileMaterialType[LocationProfileMaterialType["Galvanized"] = 5] = "Galvanized";
    LocationProfileMaterialType[LocationProfileMaterialType["HDPE"] = 6] = "HDPE";
    LocationProfileMaterialType[LocationProfileMaterialType["Unknown"] = 7] = "Unknown";
    LocationProfileMaterialType[LocationProfileMaterialType["Brass"] = 8] = "Brass";
})(LocationProfileMaterialType = exports.LocationProfileMaterialType || (exports.LocationProfileMaterialType = {}));
//# sourceMappingURL=LocationProfileMaterialType.js.map